export const DEFAULT_DEPARTMENT_GROUP = {
  key: 'other',
  label: 'Other Departments',
  prefixes: []
};

export const DEPARTMENT_GROUPS = [
  {
    key: 'sales',
    label: 'Sales & Marketing',
    prefixes: ['sales', 'sales & marketing', 's&m', 'marketing', 'product expert', 'cpo', 'pre-owned', 'pre owned', 'new vehicles', 'used vehicles', 'receptionist']
  },
  {
    key: 'service',
    label: 'Service',
    prefixes: ['service', 'after-sales', 'after sales', 'after-sales service', 'customer service', 'technician', 'workshop', 'foreman', 'warranty', 'advisor', 'bookings', 'costing', 'crm', 'clo']
  },
  {
    key: 'parts',
    label: 'Parts',
    prefixes: ['parts', 'parts & logistics', 'parts and logistics', 'warehouse', 'logistics']
  },
  {
    key: 'finance',
    label: 'Finance & Insurance',
    prefixes: ['finance', 'mbfs', 'financial services', 'f and i', 'f&i', 'insurance']
  },
  {
    key: 'management',
    label: 'Management',
    prefixes: ['management', 'manager', 'director', 'principal', 'dp', 'dealer principal', 'ceo', 'coo', 'cfo', 'rsm', 'regional', 'executive', 'head of', 'general manager', 'gm']
  },
  {
    key: 'operations',
    label: 'Operations & Support',
    prefixes: ['operations', 'support', 'supply chain', 'admin', 'administration', 'reception', 'hr', 'human resources', 'network', 'fleet']
  },
  {
    key: 'it',
    label: 'IT & Digital',
    prefixes: ['it', 'digital', 'technology', 'systems', 'dta', 'data', 'product']
  }
];

const normalise = (value) => (value || '').trim().toLowerCase();

export const resolveDepartmentGroup = (departmentName) => {
  const normalised = normalise(departmentName);
  if (!normalised) {
    return DEFAULT_DEPARTMENT_GROUP;
  }

  // Helper: try matching a normalised string against all group prefixes
  const tryMatch = (str) => {
    for (const group of DEPARTMENT_GROUPS) {
      if (!Array.isArray(group.prefixes)) continue;
      const match = group.prefixes.some((prefix) => {
        const normalisedPrefix = normalise(prefix);
        return normalisedPrefix && str.startsWith(normalisedPrefix);
      });
      if (match) return group;
    }
    return null;
  };

  // 1. Try full department name first
  const directMatch = tryMatch(normalised);
  if (directMatch) return directMatch;

  // 2. If format is "X - Y" or "X – Y", try matching on the suffix part (Y)
  const separatorMatch = normalised.match(/^.+?\s*[-–]\s*(.+)$/);
  if (separatorMatch) {
    const suffix = normalise(separatorMatch[1]);
    const suffixMatch = tryMatch(suffix);
    if (suffixMatch) return suffixMatch;
  }

  return DEFAULT_DEPARTMENT_GROUP;
};

